import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LoginErrorModal = ({ loginError }: { loginError: string }) => {
  const [hidden, setHidden] = useState(loginError === '');
  const { t } = useTranslation();

  useEffect(() => {
    setHidden(!loginError);
  }, [loginError]);

  const close = () => setHidden(true);

  return (
    <Dialog open={!hidden} onClose={close}>
      <DialogTitle>{t('connection')}</DialogTitle>
      <DialogContent>
        <DialogContentText color="error">{loginError}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} autoFocus>
          {t('retry')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginErrorModal;
